import React from "react";
import { Error } from "./index";
import { useField } from "formik";

type DateFieldProps = {
  ariaDescribedBy?: string;
  name: string;
  placeholder?: string;
};

type stylesType = {
  touched: boolean;
  error: undefined | string;
};

export function styles({ touched, error }: stylesType) {
  const base = "p-2 w-full border rounded";
  if (touched && error) {
    return base + " border-red-500 border-2";
  } else {
    return base + " border-gray-600";
  }
}

function DateField({
  ariaDescribedBy = "",
  name,
  placeholder,
}: DateFieldProps) {
  const [field, { touched, error }] = useField({
    name,
    type: "date",
  });

  const errorId = `${name}ErrorDescription`;
  const calculatedAriaDescribedBy = `${ariaDescribedBy} ${
    error ? errorId : ""
  }`;

  return (
    <>
      <input
        {...field}
        aria-describedby={calculatedAriaDescribedBy}
        aria-invalid={error ? "true" : undefined}
        name={name}
        id={name}
        data-testid={`${name}-date`}
        placeholder={placeholder}
        className={styles({ touched, error })}
        type="date"
      />
      <div className="mt-2 md:mt-1">
        {touched && error && <Error id={errorId} errorText={error} />}
      </div>
    </>
  );
}

export default DateField;
